module.exports = __webpack_public_path__ + "img/projects.d1eed98b.svg";